import React, { useState, useEffect, useRef } from 'react';
import ParsedUrl from './ParsedUrl';
import LinkedMenu from './LinkedMenu';

const SearchInput = React.forwardRef((props, ref) => {
  const {
    menuShown,
    value,
    needFocus,
    onChange,
    className,
    onBlur,
    ...other
  } = props;

  const [searchValue, setSearchValue] = useState(value);
  const [edit, setEdit] = useState(false);
  const [showUrlMenu, setShowUrlMenu] = useState(false);
  const inputRef = useRef(ref);

  useEffect(() => {
    setSearchValue(value);
    if (!value) {
      setEdit(true);
      inputRef.current && inputRef.current.focus();
    }
  }, [value, needFocus]);

  const enableEditMode = (e) => {
    e.currentTarget.nextSibling.focus();
    setEdit(true);
  }

  const disableEditMode = (e) => {
    setEdit(false);
    onBlur(e);
  }

  const selectContent = (e) => {
    e.currentTarget.select();
  }

  const clickOnHttpIcon = () => {
    setShowUrlMenu(!showUrlMenu);
  }

  const handleClickOutside = () => {
    setShowUrlMenu(false);
  }

  const handleOnChange = (e) => {
    if (typeof onChange === 'function') {
      onChange(e);
    }
    setSearchValue(e.currentTarget.value);
  }

  const isHttp = (value) => {
    try {
      const url = new URL(value);
      return url.protocol === 'http:';
    } catch (e) {
      return false;
    }
  }

  const getIconByUrl = (value) => {
    return isHttp(value)
            ? 'icofont-info-circle'
            : 'icofont-lock';
  }

  const httpSchema = isHttp(value);
  const iconClass = getIconByUrl(value);

  const inputClass = httpSchema && 'searchbar__input--not-secure';
  const menuActivationClass = menuShown ? 'searchbar__input--flat' : 'searchbar__input';

  return (
    <span className="search-wrapper" ref={ref}>
      { !edit &&
        <div onClick={enableEditMode} className={`searchbar__url ${httpSchema && 'searchbar__input--not-secure' }`}>
          <ParsedUrl url={searchValue}/>
        </div>
      }
      <input
        type="search"
        ref={inputRef}
        onBlur={disableEditMode}
        onFocus={selectContent}
        className={`${inputClass} ${menuActivationClass}`}
        {...other}
        value={searchValue}
        onChange={handleOnChange}
      />
      <LinkedMenu
        className="popup-menu--info"
        show={showUrlMenu}
        onClickOutside={handleClickOutside}
      >
        <i
          onClick={clickOnHttpIcon}
          className={`http-menu-icon ${iconClass} ${httpSchema ? 'http-icon--not-secure' : 'http-icon--secure'} ${showUrlMenu ? 'active' : ''}`}>
          {httpSchema && <span className="title--not-secure">Not Secure</span>}
        </i>
        <div className="chrome-tab-close">
          <i className="icofont-close" onClick={handleClickOutside}></i>
        </div>
        <div className={`popup-menu__header ${httpSchema ? 'not-secure' : 'ok'} menu-item`}>
          { httpSchema ? 'Connection is not secure' : 'Connection is secure' }
        </div>
        <div className="popup-menu__descr ok menu-item">
          {
            httpSchema
            ? 'You should not enter any sensitive information on this site (for example, passwords or credit cards), because it could be stolen by attackers.'
            :'Your information (for example, passwords or credit card numbers) is private when it is sent to this site.'
          }
        </div>
        <hr className="menu-item--split" />
        <div className="menu-item menu-item--selectable">
          <i className="icofont-license"></i>
          <span className="menu-item__title">Certificate</span>
          <span className="menu-item__status">(valid)</span>
        </div>
        <div className="menu-item menu-item--selectable">
          <i className="icofont-paint"></i>
          <span className="menu-item__title">Cookies</span>
          <span className="menu-item__status">(1 use)</span>
        </div>
        <div className="menu-item menu-item--selectable">
          <i className="icofont-options"></i>
          <span className="menu-item__title">Site settings</span>
        </div>
      </LinkedMenu>
      <i className="icofont-star star-icon"></i>
    </span>
  );
});

export default SearchInput;
